/**
 * 平台结算表单校验与绑定状态（2026-06-08）
 * 字段规则对齐旧 toPlatform.vue checkAddresMsg
 */

export const SETTLEMENT_STORAGE_KEY = "settlementInfo";

export function getDefaultCountryList(t) {
  return [
    { name: t("guild_page_saudi"), code: "SA" },
    { name: t("guild_page_morocco"), code: "MA" },
  ];
}

export const SA_BANK_LIST = [
  "ARAB_NATIONAL",
  "AL_BILAD",
  "AL_INMA",
  "AL_JAZIRA",
  "AL_RAJHI",
  "BANQUE_SAUDI_FRANSI",
  "GULF_INTERNATIONAL",
  "RIYADBANK",
  "SAUDI_BRITISH",
  "SAUDI_INVESTMENT",
  "SAUDI_NATIONAL",
];

export function createEmptySettlementForm(t) {
  const countryList = getDefaultCountryList(t);
  return {
    country: countryList[0],
    bank: SA_BANK_LIST[0],
    name: "",
    bankAccount: "",
    address: "",
  };
}

/** 是否已填写完整绑定信息（不依赖 i18n） */
export function isSettlementBound(form = {}) {
  const name = (form.name || "").trim();
  const address = (form.address || "").trim();
  // 姓名与地址任一为空即未绑定
  if (!name || !address) return false;

  // 姓名与地址必须为英文字符（含空格、逗号、点、连字符、撇号）
  const englishRegex = /^[a-zA-Z\s,.'-]+$/;
  if (!englishRegex.test(name) || !englishRegex.test(address)) return false;

  // 沙特国家：银行账号必填且必须以 "SA" 开头（IBAN 格式）
  if ((form.country || {}).code === "SA") {
    const bankAccount = (form.bankAccount || "").trim();
    if (!bankAccount || !bankAccount.startsWith("SA")) return false;
  }

  return true;
}

export function validateSettlementForm(form = {}, t) {
  const name = (form.name || "").trim();
  const address = (form.address || "").trim();
  const country = form.country || {};

  // 姓名必填
  if (!name) {
    return { valid: false, message: t("guild_page_name_english") };
  }
  // 地址必填
  if (!address) {
    return { valid: false, message: t("guild_page_address_english") };
  }

  // 姓名必须为英文字符
  const englishRegex = /^[a-zA-Z\s,.'-]+$/;
  if (!englishRegex.test(name)) {
    return { valid: false, message: t("guild_page_name_english") };
  }
  // 地址必须为英文字符
  if (!englishRegex.test(address)) {
    return { valid: false, message: t("guild_page_address_english") };
  }

  // 沙特国家：银行账号必填且必须以 "SA" 开头
  if (country.code === "SA") {
    const bankAccount = (form.bankAccount || "").trim();
    if (!bankAccount) {
      return { valid: false, message: t("guild_page_enter") };
    }
    if (!bankAccount.startsWith("SA")) {
      return { valid: false, message: t("guild_page_enter") };
    }
  }

  return { valid: true };
}

export function loadSettlementInfo(uid, t) {
  try {
    const raw = localStorage.getItem(SETTLEMENT_STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    // 缓存的 uid 与当前用户不一致时清除缓存，避免串号
    if (String(data.uid) !== String(uid)) {
      localStorage.removeItem(SETTLEMENT_STORAGE_KEY);
      return null;
    }
    // 各字段取缓存值，缺省时回退到默认国家/银行
    return {
      country: data.country || getDefaultCountryList(t)[0],
      bank: data.bank || SA_BANK_LIST[0],
      name: data.name || "",
      bankAccount: data.bankAccount || "",
      address: data.address || "",
    };
  } catch (e) {
    // JSON 解析失败视为无缓存
    return null;
  }
}

export function saveSettlementInfo(uid, form) {
  // 连同 uid 一起持久化，便于下次按用户校验
  localStorage.setItem(
    SETTLEMENT_STORAGE_KEY,
    JSON.stringify({
      uid,
      country: form.country,
      name: form.name,
      address: form.address,
      bank: form.bank,
      bankAccount: form.bankAccount,
    })
  );
}

/** 平台结算确认页收款信息展示行 */
export function buildSettlementConfirmRows(form = {}, t) {
  const rows = [];
  // 收集器：label 与 value 都非空才入行
  const push = (label, value) => {
    if (label && value) rows.push({ label, value });
  };
  const country = form.country || {};

  // 国家始终展示；沙特额外展示银行与银行账号
  push(t("guild_page_country"), country.name);
  if (country.code === "SA") {
    push(t("guild_page_bank"), form.bank);
  }
  push(t("guild_page_name"), form.name);
  if (country.code === "SA") {
    push(t("guild_page_bank_number"), form.bankAccount);
  }
  push(t("guild_page_address"), form.address);
  return rows;
}
